<template>
  <div :class="['social-services', 'hidden-xs-only', 'unselectable', $root.config.colors.primary, 'elevation-8']">
    <ul>
      <li v-for="(service, index) in services" :key="index" v-if="service.show">
        <v-btn @click="popup(service.url(getLocation(), $lang.appName))" aria-label="share" icon small dark :class="['ma-1']" :title="$lang.shareOn(firstLetterCapital(service.icon))">
          <v-icon>mdi-{{ service.icon }}</v-icon>
        </v-btn>
      </li>
    </ul>
  </div>
</template>
<script>
import services from '../helpers/social-bar-services'
import methods from '../mixins/methods'

export default {
  name: 'SocialServices',
  mixins: [
    methods
  ],
  data () {
    return {
      services
    }
  },
  methods: {
    firstLetterCapital (string) {
      if (typeof string !== 'string') {
        return ''
      }
      return string.charAt(0).toUpperCase() + string.slice(1)
    },
    getLocation () {
      return location.href
    },
    /**
     * Open url in a popup
     * @method popup
     * @param {string} url
     * @param {string} title
     * @param {number} width
     * @param {number} height
     * @return {object}
     */
    popup (url = window.location.href, title = '', width = 640, height = 480) {
      const left = (screen.width / 2) - (width / 2)
      const top = (screen.height / 2) - (height / 2)
      this.gtagEvent('click', 'share', url.split('/')[2])
      return window.open(url, title, `width=${width}, height=${height}, top=${top}, left=${left}, toolbar=no, location=no, directories=no, status=no, menubar=no, scrollbars=no, resizable=no, copyhistory=no`)
    }
  }
}
</script>
<style>
.social-services ul,
.social-services li
{
  padding: 0;
  margin: 0;
  list-style: none;
}

.social-services
{
  position: fixed;
  top: 50%;
  right: 0;
  transform: translateY(-50%);
  border-radius: 4px 0 0 4px;
}
</style>



// WEBPACK FOOTER //
// src/components/social-services.vue